export const languageStringsSubscriptions = {
  title: "Abonament",
  successPayment: "Płatność została poprawnie zrealizowana.",
  successPaymentDescription: "Za moment punkty pojawią się na Twoim koncie.",
  wantToChangeSubscription: "Czy na pewno chcesz zmienić plan ",
  changeFrom: "z ",
  changeTo: " na ",
  subTitle: "Twój abonament",
  portableCreditsDescription:
    "Punkty te nie tracą ważności. Zostaną wykorzystane po przekroczeniu wysokości miesięcznej puli punktów.",
  tarifs: {
    title: "Plany",
    monthly: "Miesięcznie",
    yearly: "Rocznie",
    monthlyPeriod: "miesięczny",
    yearlyPeriod: "roczny",
    freeMonths: "2 miesiące gratis",
    viewsPerMonth: "liczba wyświetleń w ciągu miesiąca",
    trial: "wersja testowa - bez ograniczeń",
    creditsRefresh: "Odnowienie punktów nastąpi: ",
    creditsExpire: "Ważność punktów wygasa: ",
    subbscription: "Abonament",
    trialVersion: "wersja testowa",
    trialVersionExpires: "Wersja testowa wygasa",
    cancelSubscription: "Anuluj odnowienie abonamentu",
    nextPayment: "Następna płatność zostanie zrealizowana automatycznie",
    unlimitedVersion: "Aktywna nieograniczona wersja aplikacji",
    choseSubscription: "Wybierz plan",
    to: "Do",
    monthlyViews: "wyświetleń stron miesięcznie",
    pricesAreFinal: "Podane ceny są ostateczne.",
    moreViews:
      "Czy Twoja witryna ma jeszcze więcej wyświetleń w ciągu miesiąca?",
    contactUsForCustom:
      "Skontaktuj się z nami w celu uzgodnienia planu na miarę.",
    notificationsWithStatistics: "Notyfikacja ze statystykami odwiedzalności",
    notificationsWithLastOrdersAndRegistrations:
      "Notyfikacja ostatnich zamówień i rejestracji",
    notificationPersonalization: "Personalizacja notyfikacji",
    zboziAndHeureka: "Notyfikacja opinii z portalu Heureka i Zboží.cz",
    googleRecenze: "Integracja z opiniami Google",
    trustPilot: "Integracja z Trustpilot",
    logoCancel: "Usunięcie logo",
    customBranding: "Własny branding",
    unlimitedNotifications: "Nieograniczona liczba notyfikacji",
    unlimitedWebsites: "Nieograniczona liczba witryn",
    onlyOneWebsite: "(tylko 1 witryna)",
    activateFreeTrial: "Aktywuj 14 dni gratis",
    mostFavorite: "Najpopularniejsze",
    selected: "Wybrano",
    notAvailable: "Niedostępne",
    "LITE": {
      title: "LITE",
      priceYearly: "$50",
      priceMonthly: "$5",
    },
    "MEDIUM": {
      title: "MEDIUM",
      priceYearly: "$200",
      priceMonthly: "$20",
    },
    "UNLIMITED": {
      title: "UNLIMITED",
      priceYearly: "$350",
      priceMonthly: "$35",
    },
    lite: {
      title: "LITE",
      priceYearly: "39 Kč",
      priceMonthly: "47 Kč",
    },
    start: {
      title: "START",
      priceYearly: "247 Kč",
      priceMonthly: "297 Kč",
    },
    standard: {
      title: "STANDARD",
      priceYearly: "457 Kč",
      priceMonthly: "547 Kč",
    },
    premium: {
      title: "PREMIUM",
      priceYearly: "833 Kč",
      priceMonthly: "997 Kč",
    },
  },
};
